import { createElement, useState } from 'react';
import './index.scss';
import { Button } from 'antd';
import { useInterval } from 'ahooks';
import dayjs from 'dayjs';
const ColorfulButton = function ColorfulButton({ type = 'primary', color, style = {}, disabled, ...otherProps }) {
    const [count, setCount] = useState(0);
    useInterval(() => {
        setCount(count + 1);
    }, 1000);
    return (createElement("div", null,
        createElement(Button, { color: color, size: 'large', type: 'primary' }, dayjs().format('HH:mm:ss'))));
};
ColorfulButton.displayName = 'ColorfulButton';
export default ColorfulButton;
